import styled from "styled-components";

export const ModalCriativoMensagemStyled = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  z-index: 2;

  .div-body {
    width: 90%;
    max-width: 600px;
    padding: 50px;
    background-color: var(--base01);
    margin: 0 auto;
    border-radius: 8px;
    position: relative;
  }

  .close {
    position: absolute;
    top: -15px;
    right: -15px;
    color: var(--base01);
    background-color: #fa5252;
    padding: 12px 13.4px;
    font-size: 28px;
    font-weight: 300;
    border-radius: 30px;
    cursor: pointer;
  }

  .width-90 {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  h2{
    display: flex;
    margin: 0 auto 20px;
    justify-content: center;

    font-size: 17px !important;
    font-weight: 500;
    text-align: center;
  }

  h3{
    margin: 20px 0px;
    text-align: center;
  }

  textarea{
    min-width: 100%;
    max-width: 100%;
    min-height: 100px;
    max-height: 200px;
  }
  
  .buttons{
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 30px;
    margin-top: 10px;

    button, .confirmar{
      border: none;
      border-radius: 100px;
      width: 100px !important;
      padding: 4px 0px;
      font-weight: 600;
      font-size: 20px !important;
    }

    .negar{
      background-color: var(--principal) !important;
      color: var(--base01) !important;
    }
  }
`;
